// extracted by mini-css-extract-plugin
export default {"back_button":"BackButton_back_button__qPG4w","spin":"BackButton_spin__nEJvV"};